var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCompleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8145 6.23896C17.5148 5.92035 17.016 5.92035 16.7058 6.23896C16.4061 6.5468 16.4061 7.05916 16.7058 7.36629L22.3277 13.1407H3.77618C3.34373 13.1415 3 13.4945 3 13.9387C3 14.3829 3.34373 14.7474 3.77618 14.7474H22.3277L16.7058 20.5111C16.4061 20.8297 16.4061 21.3428 16.7058 21.6499C17.016 21.9685 17.5155 21.9685 17.8145 21.6499L24.7674 14.5085C25.0775 14.2006 25.0775 13.6883 24.7674 13.3811L17.8145 6.23896Z",
    fill: "#005FC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCompleteIcon);
export default __webpack_public_path__ + "static/media/arrow-complete-icon.4e3576ea.svg";
export { ForwardRef as ReactComponent };